// extracted by mini-css-extract-plugin
export default {"wrapper":"G8lwzRm6_IMKTAj3CGPb","loaderWrapper":"gJgWt2iHFLGd8tWGM3Qn","container":"aMMHz3JRvBlDmJ4piPvL","period":"aBiiqPE8DFHOgfvyQRq6","hasMultipleLines":"IFCiCUuIhh9tZJRgfvrw"};